import React from "react";
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/styles.min.css';

// import ReactImageMagnify from 'react-image-magnify';

const MyReactImageMagnify = ({ image }) => {
  return (
    <div className="magnify_wrapper">
      {/* <img */}
      {/* <ReactImageMagnify
        smallImage={{
          alt: "product",
          isFluidWidth: true,
          src: image,
          className : "product_img"
        }}
        largeImage={{
          src: image,
          width: 1500,
          height: 1100,
        }}
        enlargedImagePosition="over"
        enlargedImageContainerDimensions={{
          width: "100%",
          height: "100%",
        }}
        enlargedImageContainerStyle={{
          background: "#000",
          zIndex: 999,
        }}
      /> */}
      <InnerImageZoom 
        src={image} 
        zoomSrc={image} 
        alt="product"
        zoomType="hover" // Behaves like "enlargedImagePosition=over"
        className="product_img"
      />
    </div>
  );
};

export default MyReactImageMagnify;